"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[25],{

/***/ 10025:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ Linkage_Linkage; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../libs/matcha/recipes/EventItem/index.ts + 2 modules
var EventItem = __webpack_require__(96822);
// EXTERNAL MODULE: ../../libs/matcha/recipes/EventFlow/index.ts + 1 modules
var EventFlow = __webpack_require__(37585);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/Engineering/components/Linkage/Linkage.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







var events = [{
  label: "User Signup",
  detail: "4s"
}, {
  label: "Product Added"
}, {
  label: "Order Completed"
}, {
  label: "Push events to your favorite tools"
}];

var Linkage = function Linkage() {
  var _events$at;

  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var eventItemTokens = {
    color: theme.palette.twilio.boysenberry[60]
  };
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Inner, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(EventFlow/* default */.Z, {
      gradient: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
          stopColor: theme.palette.twilio.green[50],
          stopOpacity: "0"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
          offset: "0.48183",
          stopColor: theme.palette.twilio.green[50],
          stopOpacity: "0.5"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
          offset: "1",
          stopColor: theme.palette.twilio.green[50],
          stopOpacity: "0"
        })]
      }),
      gradientDots: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
          stopColor: theme.palette.neutrals.white[100],
          stopOpacity: "1"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
          offset: "0.489183",
          stopColor: theme.palette.neutrals.white[100],
          stopOpacity: "1"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
          offset: "1",
          stopColor: theme.palette.neutrals.white[100],
          stopOpacity: "1"
        })]
      }),
      children: [events.slice(0, -1).map(function (event) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(EventItem/* default */.ZP, {
          size: "small",
          textAlign: "center",
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EventItem/* Body */.uT, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EventItem/* Code */.EK, {
              tokens: eventItemTokens,
              children: event.label
            })
          }), event.detail && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EventItem/* Detail */.F, {
            tokens: {
              color: theme.palette.twilio.gray[40]
            },
            children: event.detail
          })]
        }, event.label);
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EventItem/* default */.ZP, {
        background: theme.palette.twilio.boysenberry[60],
        elevation: 2,
        size: "small",
        textAlign: "center",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EventItem/* Body */.uT, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EventItem/* Code */.EK, {
            tokens: {
              color: theme.palette.neutrals.white[100]
            },
            children: (_events$at = events.at(-1)) === null || _events$at === void 0 ? void 0 : _events$at.label
          })
        })
      })]
    })
  });
};

var Inner = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ew0k6ab0"
} : 0)( true ? {
  name: "dey4e4",
  styles: "min-width:min(100%, 340px);position:relative;min-height:460px;display:flex;flex-direction:column;justify-content:center;width:fit-content;margin:0 auto"
} : 0);

/* harmony default export */ var Linkage_Linkage = (Linkage);
;// CONCATENATED MODULE: ./src/views/Engineering/components/Linkage/index.ts


/***/ })

}]);